import { NodeEdgeMapper } from '@iotv/datamodel-core';
import ApiGateway from '../../aws/api-gateway/ApiGateway';
const debug = process.env.REACT_APP_DEBUG && false;
export const getGraphQueryRequestV2 = async ({ contextObjects, query }) => {
    const res = { err: null, data: null };
    const dehydratedQuery = query.dehydrate();
    const params = { contextObjects, dehydratedQuery };
    debug && console.log('getGraphQueryRequestV2 params', params);
    const path = `/query/graph`;
    const apiRes = (await ApiGateway.post(path, params, 'ConsumerApi'));
    debug && console.log('getGraphQueryRequestV2 apiRes', apiRes);
    if (apiRes.data) {
        res.data = new NodeEdgeMapper(apiRes.data);
    }
    else {
        res.err = apiRes.err;
    }
    return res;
};
export const getGraphQueryRequestData = async ({ contextObjects, query }) => {
    const res = { err: null, data: null };
    const dehydratedQuery = query.dehydrate();
    const params = { contextObjects, dehydratedQuery };
    debug && console.log('getGraphQueryRequestV2 params', params);
    const path = `/query/graph`;
    const apiRes = await ApiGateway.post(path, params, 'ConsumerApi');
    debug && console.log('getGraphQueryRequestV2 apiRes', apiRes);
    if (apiRes.data) {
        res.data = apiRes.data;
    }
    else {
        res.err = apiRes.err;
    }
    return res;
};
